import styles from '../ProductQuiz.module.scss';
import React, { useEffect } from 'react';
import { Button, Flex, Text } from '@mantine/core';
import { useProductQuiz } from '../ProductQuizContext';
import { QuestionTitle } from './QuestionTitle';
import { ReactComponent as SuburbsIcon } from '../../../assets/images/icons/icon_suburbs.svg';
import { ReactComponent as CityIcon } from '../../../assets/images/icons/icon_city.svg';
import { ReactComponent as OutdoorsIcon } from '../../../assets/images/icons/icon_outdoors.svg';
import { quizQuestionPage } from '../../../lib/analytics/events';
import { useTranslation } from 'react-i18next';

const RESIDENCES = [
  {
    name: 'City',
    icon: (className: string) => <CityIcon className={className} />,
  },
  {
    name: 'Suburbs',
    icon: (className: string) => <SuburbsIcon className={className} />,
  },
  {
    name: 'Great outdoors',
    icon: (className: string) => <OutdoorsIcon className={className} />,
  },
];

export const QuestionResidence: React.FC = () => {
  const { t } = useTranslation();
  useEffect(() => {
    quizQuestionPage.quizPetLocationPageEntered();
  }, []);

  const { quizAnswers, setQuizAnswers, nextQuestion } = useProductQuiz();

  const items = RESIDENCES.map(({ name, icon }) => (
    <Button
      key={name}
      unstyled
      data-active={quizAnswers.residence === name || undefined}
      className={styles.quizButton}
      onClick={() => {
        quizQuestionPage.quizPetLocationNext(name);
        setQuizAnswers({ ...quizAnswers, residence: name });
        nextQuestion();
      }}
      sx={{
        height: '100px',
        borderRadius: 16,
      }}
    >
      <Flex align="center" justify="flex-start" gap="md" style={{ padding: '0 20px', width: '100%' }}>
        {icon(quizAnswers.residence === name ? styles.iconYellow : styles.iconWhite)}
        <Text
          sx={(theme) => ({
            fontSize: 24,
            fontWeight: 600,
            lineHeight: '120%',
            letterSpacing: '-0.48px',
            color: quizAnswers.residence === name ? theme.colors['fi-yellow'] : 'white',
          })}
        >
          {name}
        </Text>
      </Flex>
    </Button>
  ));

  return (
    <>
      <QuestionTitle>{t('where_does_name_live', { name: quizAnswers.petName })}</QuestionTitle>
      <Flex w="100%" p="md" direction="column" gap={16} align="stretch" px={0}>
        {items}
      </Flex>
    </>
  );
};
